// Controller
import {
  auctionController,
  mySupplierCompanyController,
} from '../apiController'

class auctionService {
  getAuctionByID = async id => {
    try {
      const resp = await auctionController().getAuctionById(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET AUCTION BY ID ERROR:', err)
    }
    return false
  }

  getSupplierListByID = async id => {
    try {
      const resp = await auctionController().getSupplierListCompare(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET SUPPLIER LIST BY ID ERROR:', err)
    }
    return false
  }

  getAuctionBySupplierID = async id => {
    try {
      const resp = await mySupplierCompanyController().getAuctionSupplierID(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET AUCTION BY SUPPLIER ID ERROR:', err)
    }
    return false
  }

  getAuctionBySupplier = async id => {
    try {
      const resp = await mySupplierCompanyController().getAuctionSupplier(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET AUCTION SUPPLIER ERROR:', err)
    }
    return false
  }

  getAuctionItemBySupplierID = async id => {
    try {
      const resp = await mySupplierCompanyController().getAuctionItem(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET AUCTION ITEM BY SUPPLIER ID ERROR:', err)
    }
    return false
  }

  getAuctionItemByBuyerID = async id => {
    try {
      const resp = await auctionController().getAuctionItemById(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET AUCTION ITEM BY BUYER ID ERROR:', err)
    }
    return false
  }

  getDummyListByID = async id => {
    try {
      const resp = await auctionController().getDummyList(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET DUMMY LIST BY ID ERROR:', err)
    }
    return false
  }

  getSupplierBidHistoryListByEventId = async id => {
    try {
      const resp = await auctionController().getSupplierBidHistoryList(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET SUPPLIER BID HISTORY LIST BY EVENT ID ERROR:', err)
    }
    return false
  }

  getRankingBidByEventId = async id => {
    try {
      const resp = await auctionController().getRankingBid(id)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET RANKING BID BY EVENT ID ERROR:', err)
    }
    return false
  }

  getBidHistoryOfSupplierByEventIdNUserId = async (event_id, user_id) => {
    try {
      const resp = await auctionController().getBidHistoryOfSupplier(
        event_id,
        user_id
      )
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log(
        'GET BID HISTORY OF SUPPLIER BY EVENT ID AND USER ID ERROR:',
        err
      )
    }
    return false
  }

  getItemsBidHistoryOfSupplierByEventIdNUserId = async (event_id, user_id) => {
    try {
      const resp = await auctionController().getItemsBidHistoryOfSupplier(
        event_id,
        user_id
      )
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log(
        'GET ITEM OF BID HISTORY OF SUPPLIER BY EVENT ID AND USER ID ERROR:',
        err
      )
    }
    return false
  }

  getAuctionBiddingHistoryByAuctionIdNUserId = async (auction_id, user_id) => {
    try {
      const resp = await auctionController().getAuctionBiddingHistory(
        auction_id,
        user_id
      )
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log(
        'GET AUCTION BIDDING HISTORY BY AUCTION ID AND USER ID ERROR:',
        err
      )
    }
    return false
  }

  getBiddingHistoryOfSupplierByAuctionId = async auction_id => {
    try {
      const resp = await auctionController().getBiddingHistoryOfSupplier(
        auction_id
      )
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log(
        'GET AUCTION BIDDING HISTORY BY AUCTION ID AND USER ID ERROR:',
        err
      )
    }
    return false
  }

  getAuctionEventCloseLogByEventId = async event_no => {
    try {
      const resp = await auctionController().getAuctionEventCloseLog(event_no)
      if (resp) {
        return resp
      }
    } catch (err) {
      console.log('GET AUCTION EVENT CLOSE LOG BY EVENT NO ERROR:', err)
    }
    return false
  }
}

export default new auctionService()
